var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbuntu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5C0 19.4036 5.59644 25 12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5Z",
    fill: "#E95420"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58858 14.8534C7.01822 14.8534 8.17717 13.6945 8.17717 12.2649C8.17717 10.8352 7.01822 9.67627 5.58858 9.67627C4.15895 9.67627 3 10.8352 3 12.2649C3 13.6945 4.15895 14.8534 5.58858 14.8534Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3698 9.17717C17.7995 9.17717 18.9584 8.01822 18.9584 6.58858C18.9584 5.15895 17.7995 4 16.3698 4C14.9402 4 13.7812 5.15895 13.7812 6.58858C13.7812 8.01822 14.9402 9.17717 16.3698 9.17717Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4269 18.9282C9.5617 18.5286 8.00363 17.3377 7.12765 15.6487C6.43768 15.9627 5.66111 16.0581 4.91406 15.9203C5.9741 18.5237 8.22213 20.4144 10.982 21.006C11.5873 21.1359 12.2044 21.1989 12.8206 21.1949C12.3452 20.5699 12.0804 19.816 12.0627 19.0306C11.8491 19.007 11.6365 18.9725 11.4278 18.9272L11.4269 18.9282Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7878 21.5304C17.2174 21.5304 18.3764 20.3715 18.3764 18.9419C18.3764 17.5122 17.2174 16.3533 15.7878 16.3533C14.3582 16.3533 13.1992 17.5122 13.1992 18.9419C13.1992 20.3715 14.3582 21.5304 15.7878 21.5304Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3896 17.9912C20.1947 16.9764 20.7616 15.7766 21.0342 14.502C21.5106 12.2786 21.0657 9.94593 19.8138 8.0542C19.5155 8.75696 19.0096 9.35046 18.3581 9.75892C19.0569 11.0759 19.2695 12.5955 18.9565 14.0572C18.8029 14.7727 18.5323 15.4469 18.1514 16.0631C18.7606 16.5631 19.1907 17.2353 19.3905 17.9922L19.3896 17.9912Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38868 8.5522C5.45462 8.54826 5.52057 8.54728 5.58553 8.54728C5.84734 8.54728 6.10817 8.57484 6.36703 8.63094C6.78927 8.72149 7.18592 8.88094 7.54911 9.10732C8.71447 7.43113 10.5954 6.42523 12.6328 6.38783C12.6436 6.19196 12.6702 5.99708 12.7105 5.80515C12.8296 5.25102 13.0718 4.73232 13.4182 4.28842C10.1623 4.03055 6.99892 5.71066 5.3877 8.55318L5.38868 8.5522Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbuntu);
export default __webpack_public_path__ + "static/media/ubuntu.a07d9f12aa44f9c3885c2144a3dac96f.svg";
export { ForwardRef as ReactComponent };